import Cookies from 'js-cookie';

export default {
  isNewRepoEnabled() {
    return Cookies.get('new_repo') === 'true';
  },
};



// WEBPACK FOOTER //
// ./helpers/user_feature_helper.js